import { createSlice } from '@reduxjs/toolkit';

type IBBCommonState = {
  openedModalIds: Array<string>;
};

const initialState: IBBCommonState = {
  openedModalIds: [],
};

const bbcommonSlice = createSlice({
  name: 'bbcommon',
  initialState,
  reducers: {},
});

export default bbcommonSlice.reducer;
